import { useAppMessage } from "../components/common/AppMessageProvider";
import { extractErrorMessage } from "../utils/apiError";

export default function useMessageHelpers() {
    const msg = useAppMessage();

    const showLoading = (content = "Đang xử lý...", key = `msg-${Date.now()}`) => {
        msg.open({ type: "loading", content, key, duration: 0 });
        return key; // trả về key để update tiếp theo bằng cùng key
    };

    const showSuccess = (content = "Thành công", key) => {
        msg.open({ type: "success", content, key, duration: 1.2 });
    };

    const showError = (errorOrMessage = "Có lỗi xảy ra", key) => {
        const content = typeof errorOrMessage === 'string'
            ? errorOrMessage
            : extractErrorMessage(errorOrMessage);

        msg.open({ type: "error", content, key, duration: 2 });
    };

    const showInfo = (content = "Thông báo", key) => {
        msg.open({ type: "info", content, key, duration: 1.5 });
    };

    return { showLoading, showSuccess, showError, showInfo };
}
